import { realtimedb, db } from "@/plugins/firebase";

export class FirebaseService {
  public static getRealTimeDatabaseReference(companyId, deviceId): firebase.database.Reference {
    return realtimedb.ref().child(`DeviceSettings/${companyId}/DeviceSettingsPOS/${deviceId}`);
  }

  public static getFirestoreDatabaseReference(companyId, deviceId): firebase.firestore.DocumentReference<firebase.firestore.DocumentData> {
    return db
      .collection("DeviceSettings")
      .doc(companyId)
      .collection("DeviceSettingsPOS")
      .doc(deviceId);
  }
}
